import { useEffect, useState } from 'react';

import cn from 'classnames';
import { Badge } from 'react-bootstrap';

import { IconButton } from 'components/IconButton/IconButton';

import styles from './BulkActionsBar.module.scss';

export const BulkActionsBar = ({
  active,
  selectedIds,
  totalMatchingCount,
  onUseAllChange = () => {},
  handleClose = () => {},
  children,
}) => {
  const [useAll, setUseAll] = useState(false);

  useEffect(() => setUseAll(false), [selectedIds]);

  useEffect(() => onUseAllChange(useAll), [useAll]);

  const badgeLabel = useAll
    ? totalMatchingCount != null
      ? `All ${totalMatchingCount} matching records selected`
      : 'use all'
    : totalMatchingCount != null
      ? `${selectedIds.length} selected · Select all ${totalMatchingCount} matching`
      : `${selectedIds.length} selected`;

  return (
    <div className={cn(styles.root, 'u-drop-shadow--large', { [styles.hidden]: !active })}>
      <Badge className={styles.badge} onClick={() => setUseAll(!useAll)}>
        {badgeLabel}
      </Badge>
      <div className={styles.divider} />
      <div className={styles.actionsWrapper}>
        {children}
        <IconButton icon="x" onClick={handleClose} />
      </div>
    </div>
  );
};
